<template>
    <div class="main-container">
		<LogoComponent
            @click="$router.push('/')"
        />
        <v-card
            class="card-container"
            outlined>
            <h1>Welcome back</h1>
            <form action="" class="form-container">
                <v-text-field
                    label="Email"
                    type="email"
                    v-model="user.email"
                    @blur="validateEmail()"
                    :error-messages="userErrors.emailErrors"
                    outlined
                    solo
                    flat
                    :height="50"
                    color="#18125a"
                ></v-text-field>
                <v-text-field
                    label="Password"
                    type="password"
                    v-model="user.password"
                    @blur="validatePassword()"
                    :error-messages="userErrors.passwordErrors"
                    outlined
                    solo
                    flat
                    :height="50"
                    color="#18125a"
                ></v-text-field>
                <button type="button" @click="validateForm()">Log in</button>
            </form>
        </v-card>
    </div>
</template>

<script>
import LogoComponent from '@/components/LogoComponent';
import store from '@/services/business/store';

export default {
    name: 'LoginPage',
    metaInfo: {
		title: 'Log in - LensAdvisors Business',
		meta: [
			{ vmid: 'description', name: 'description', content: 'Log into LensAdvisors and manage your business ads' }
		]
	},
    data: () => {
        return {
            user: {
                email: null,
                password: null
            },
            userErrors: {
                emailErrors: [],
                passwordErrors: []
            }
        }
    },
    components: {
        LogoComponent
    },
    methods: {
        validateForm() {
			if (this.validateEmail() & this.validatePassword()) {
                this.$cookies.remove('csrftoken');
                this.$cookies.remove('sessionid');
                store.login(
                    this.user.email,
                    this.user.password,
                    () => this.$router.push('onboarding'),
                    () => this.$router.push('dashboard')
                );
			}
		},
        validateEmail() {
			this.userErrors.emailErrors = [];
			if (!this.user.email) {
				this.userErrors.emailErrors.push('Your email is required');
			}
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(this.user.email).toLowerCase())) {
				this.userErrors.emailErrors.push('Invalid email');
			}
			return !this.userErrors.emailErrors.length > 0;
		},
		validatePassword() {
			this.userErrors.passwordErrors = [];
			if (!this.user.password) {
				this.userErrors.passwordErrors.push("Don't forget your password!");
			}
			return !this.userErrors.passwordErrors.length > 0;
		},
    }
};
</script>

<style lang="scss" scoped>
    .main-container {
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;

        .card-container {
            height: 50%;
            min-height: 450px;
            width: 25%;
            min-width: 350px;
            padding: 20px;
            display: flex;
            flex-direction: column;

            h1 {
                text-align: center;
            }

            .form-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin: auto 0;

                button {
                    background: #e79831;
                    color: white;
                    font-weight: bold;
                    width: 100%;
                    height: 50px;
                    padding: 5px;
                    border-radius: 5px;
                    font-size: 1rem;
                }
            }
        }
    }
</style>